import React from 'react';
import CxInput from '../../cx/CxInput';
import CxDate from '../../cx/CxDate';
import CxButton from '../../cx/CxButton';
import CxStatic from '../../cx/CxStatic';
import CxCombo from '../../cx/CxCombo';
import * as FxFetch from '../../fx/FxFetch';
import * as FxLog from '../../fx/FxLog';

const messages = {
  formTitle: {
    es: 'Formulario de Datos',
    en: 'Data Form',
    de: 'Datenformular',
    ru: 'Форма данных',
  },
  sendData: {
    es: 'Enviar datos',
    en: 'Send data',
    de: 'Daten senden',
    ru: 'Отправить данные',
  },
  sending: {
    es: 'Enviando datos...',
    en: 'Sending data...',
    de: 'Daten werden gesendet...',
    ru: 'Отправка данных...',
  },
  success: {
    es: 'Datos enviados correctamente',
    en: 'Data sent successfully',
    de: 'Daten erfolgreich gesendet',
    ru: 'Данные успешно отправлены',
  },
  requiredClient: {
    es: 'El nombre y apellidos del cliente son obligatorios',
    en: 'Client first and last name are required',
    de: 'Vor- und Nachname des Kunden sind erforderlich',
    ru: 'Имя и фамилия клиента обязательны',
  },
  sendError: {
    es: 'Error al enviar datos',
    en: 'Error sending data',
    de: 'Fehler beim Senden der Daten',
    ru: 'Ошибка при отправке данных',
  },
  unexpectedError: {
    es: 'Error inesperado al enviar datos',
    en: 'Unexpected error sending data',
    de: 'Unerwarteter Fehler beim Senden der Daten',
    ru: 'Неожиданная ошибка при отправке данных',
  },

  tutorTitle: {
    es: 'Datos del Tutor',
    en: 'Client Data',
    de: 'Kundendaten',
    ru: 'Данные клиента',
  },

  patientTitle: {
    es: 'Datos de la mascota',
    en: 'Pet Data',
    de: 'Haustierdaten',
    ru: 'Данные питомца',
  },
  addPatient: {
    es: 'Añadir mascota',
    en: 'Add Pet',
    de: 'Haustier hinzufügen',
    ru: 'Добавить питомца',
  },
  savePatient: {
    es: 'Guardar mascota',
    en: 'Save Pet',
    de: 'Haustier speichern',
    ru: 'Сохранить питомца',
  },
  cancelPatient: {
    es: 'Cancelar',
    en: 'Cancel',
    de: 'Abbrechen',
    ru: 'Отмена',
  },
  patientsAdded: {
    es: 'Mascotas añadidas',
    en: 'Added Pets',
    de: 'Hinzugefügte Haustiere',
    ru: 'Добавленные питомцы',
  },

  remove: {
    es: 'Quitar',
    en: 'Remove',
    de: 'Entfernen',
    ru: 'Удалить',
  },
  nameLabel: {
    es: 'Nombre',
    en: 'Name',
    de: 'Name',
    ru: 'Имя',
  },
  firstNameLabel: {
    es: 'Nombre',
    en: 'First Name',
    de: 'Vorname',
    ru: 'Имя',
  },
  lastNameLabel: {
    es: 'Apellidos',
    en: 'Last Name',
    de: 'Nachname',
    ru: 'Фамилия',
  },
  icLabel: {
    es: 'NIF/NIE',
    en: 'ID/NIF',
    de: 'Ausweis/NIF',
    ru: 'Идентификатор/паспорт',
  },
  emailLabel: {
    es: 'e-mail',
    en: 'e-mail',
    de: 'E-Mail',
    ru: 'e-mail',
  },
  phoneLabel: {
    es: 'Teléfono',
    en: 'Phone',
    de: 'Telefon',
    ru: 'Телефон',
  },
  addressLabel: {
    es: 'Domicilio',
    en: 'Address',
    de: 'Adresse',
    ru: 'Адрес',
  },
  cityLabel: {
    es: 'Ciudad',
    en: 'City',
    de: 'Stadt',
    ru: 'Город',
  },
  postalCodeLabel: {
    es: 'Código postal',
    en: 'Postal Code',
    de: 'Postleitzahl',
    ru: 'Почтовый индекс',
  },
  speciesLabel: {
    es: 'Especie',
    en: 'Species',
    de: 'Art',
    ru: 'Вид',
  },
  breedLabel: {
    es: 'Raza',
    en: 'Breed',
    de: 'Rasse',
    ru: 'Порода',
  },
  coatLabel: {
    es: 'Color',
    en: 'Coat',
    de: 'Farbe',
    ru: 'Окрас',
  },
  genderLabel: {
    es: 'Sexo',
    en: 'Gender',
    de: 'Geschlecht',
    ru: 'Пол',
  },
  chipLabel: {
    es: 'Nº de microchip',
    en: 'Microchip No.',
    de: 'Mikrochip Nr.',
    ru: '№ микрочипа',
  },
  passportLabel: {
    es: 'Nº de pasaporte',
    en: 'Passport No.',
    de: 'Reisepass Nr.',
    ru: '№ паспорта',
  },
  birthDateLabel: {
    es: 'Fecha de Nacimiento',
    en: 'Birth Date',
    de: 'Geburtsdatum',
    ru: 'Дата рождения',
  },
  male: {
    es: 'Macho',
    en: 'Male',
    de: 'Männlich',
    ru: 'Самец',
  },
  female: {
    es: 'Hembra',
    en: 'Female',
    de: 'Weiblich',
    ru: 'Самка',
  },
};

const MxClientNci = () => {
  const formWidth = 'var(--ibs_control_width_lg)';

  const [clientData, setClientData] = React.useState({
    txClient_firstName: '',
    txClient_lastName: '',
    txIc: '',
    txEmail: '',
    txMobile: '',
    txAddress: '',
    txCity: '',
    txPostalCode: '',
  });

  const rf_clientFullName_error = React.useRef(null);

  const rfPatientRefs = {
    txAnimal: React.useRef(null),
    dtBirth: React.useRef(null),
    txTypeSpecies: React.useRef(null),
    txTypeBreed: React.useRef(null),
    txTypeCoat: React.useRef(null),
    boGender: React.useRef(null),
    txChip: React.useRef(null),
    txPassport: React.useRef(null),
  };

  const [showPatientForm, setShowPatientForm] = React.useState(false);
  const [patients, setPatients] = React.useState([]);
  const [sending, setSending] = React.useState(false);
  const [sendStatus, setSendStatus] = React.useState({ type: '', message: '' });
  const [sentOk, setSentOk] = React.useState(false);
  const [lang, setLang] = React.useState('es');
  const [companyName, setCompanyName] = React.useState('');
  const [showAddPatientButton, setShowAddPatientButton] = React.useState(false);

  React.useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const qLang = query.get('lang');
    const qCompany = query.get('cy') || '';
    const qApp = query.get('app') || '';

    const finalLang =
      qLang === 'en'
        ? 'en'
        : qLang === 'de'
        ? 'de'
        : qLang === 'ru'
        ? 'ru'
        : 'es';

    setLang(finalLang);
    setCompanyName(qCompany);
    setShowAddPatientButton(qApp === 'vett' || qApp === 'spaw');
  }, []);

  const getMessage = (key) =>
    messages[key] ? messages[key][lang] || '' : '';

  const getQueryIdi = () =>
    new URLSearchParams(window.location.search).get('idi') || '';

  const getQueryAppt = () =>
    new URLSearchParams(window.location.search).get('appt') || '';

  const handleClientChange = (field, value) => {
    setClientData((prev) => ({ ...prev, [field]: value }));
  };

  const capitalize = (str) =>
    str
      ? str
          .split(' ')
          .map(
            (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
          )
          .join(' ')
      : '';

  const addPatient = () => {
    try {
      const animalName = rfPatientRefs.txAnimal.current?.getVal?.()?.trim();
      if (!animalName) return;

      const patient = {
        txAnimal: capitalize(animalName),
        dtBirth: rfPatientRefs.dtBirth.current?.getVal?.() || '',
        txTypeSpecies: capitalize(
          rfPatientRefs.txTypeSpecies.current?.getVal?.()?.trim() || ''
        ),
        txTypeBreed: capitalize(
          rfPatientRefs.txTypeBreed.current?.getVal?.()?.trim() || ''
        ),
        txTypeCoat: capitalize(
          rfPatientRefs.txTypeCoat.current?.getVal?.()?.trim() || ''
        ),
        boGender:
          rfPatientRefs.boGender.current?.getVal?.()?.trim() || '',
        txChip:
          rfPatientRefs.txChip.current?.getVal?.()?.trim() || '',
        txPassport:
          rfPatientRefs.txPassport.current?.getVal?.()?.trim() || '',
      };

      setPatients((prev) => [...prev, patient]);
      clearPatientFields();
    } catch (error) {
      FxLog.errorx('MxClientNci.addPatient', error);
    }
  };

  const handleBottomAddPatient = () => setShowPatientForm(true);

  const clearPatientFields = () =>
    Object.values(rfPatientRefs).forEach((ref) =>
      ref.current?.setVal?.('')
    );

  const removePatient = (index) =>
    setPatients((prev) => prev.filter((_, i) => i !== index));

  const send = () => {
    try {
      const firstName = capitalize(
        clientData.txClient_firstName.trim()
      );
      const lastName = capitalize(
        clientData.txClient_lastName.trim()
      );

      if (!firstName || !lastName) {
        rf_clientFullName_error.current?.setLabel?.(
          getMessage('requiredClient'),
          'var(--ibs_color_red)'
        );
        rf_clientFullName_error.current?.setVisible?.(true);
        return;
      }

      const currentAnimal =
        rfPatientRefs.txAnimal.current?.getVal?.()?.trim();

      const lstAnimals = [...patients];

      if (currentAnimal) {
        lstAnimals.push({
          txAnimal: capitalize(currentAnimal),
          dtBirth: rfPatientRefs.dtBirth.current?.getVal?.() || '',
          txTypeSpecies: capitalize(
            rfPatientRefs.txTypeSpecies.current?.getVal?.()?.trim() || ''
          ),
          txTypeBreed: capitalize(
            rfPatientRefs.txTypeBreed.current?.getVal?.()?.trim() || ''
          ),
          txTypeCoat: capitalize(
            rfPatientRefs.txTypeCoat.current?.getVal?.()?.trim() || ''
          ),
          boGender:
            rfPatientRefs.boGender.current?.getVal?.()?.trim() || '',
          txChip:
            rfPatientRefs.txChip.current?.getVal?.()?.trim() || '',
          txPassport:
            rfPatientRefs.txPassport.current?.getVal?.()?.trim() || '',
        });
      }

      // si viene de MxClientOla (On Line Appointment), también mandamos la cita pedida al backend.
      const strAppt = getQueryAppt();
      let theAppt = {};
      if (strAppt) {
        const [_date, _from, _to, _column, _group, _reason] = strAppt.split('|');
        theAppt = {
          apptDate: _date,
          tmFrom: _from,
          tmTo: _to,
          itCalendarCol: _column,
          txTypeCalendarGrp: _group,
          rfReason: decodeURIComponent(_reason)
        };
      }

      const record = {
        txIdi: getQueryIdi(),
        objClient: {
          txClient: `${lastName}, ${firstName}`,
          ...(lang !== 'de' &&
            lang !== 'ru' && {
              txIc: clientData.txIc.trim().toUpperCase(),
            }),
          txEmail: clientData.txEmail.trim().toLowerCase(),
          txMobile: clientData.txMobile.trim(),
          txAddress: clientData.txAddress.trim(),
          txCity: clientData.txCity.trim(),
          txPostalCode: clientData.txPostalCode.trim(),
        },
        lstAnimals,
        appt: theAppt,
      };

      setSending(true);
      setSendStatus({ type: '', message: '' });

      FxFetch.doJsonX('clients/new_client_info', record)
        .then((result) => {
          if (result?.theValue === 'OK') {
            setSentOk(true);
            setSendStatus({
              type: 'success',
              message: getMessage('success'),
            });

            setClientData({
              txClient_firstName: '',
              txClient_lastName: '',
              txIc: '',
              txEmail: '',
              txMobile: '',
              txAddress: '',
              txCity: '',
              txPostalCode: '',
            });

            setPatients([]);
            setShowPatientForm(false);
            clearPatientFields();
          } else {
            setSendStatus({
              type: 'error',
              message: getMessage('sendError'),
            });
          }
        })
        .catch((err) => {
          FxLog.errorx('MxClientNci.send.catch', err);
          setSendStatus({
            type: 'error',
            message: getMessage('unexpectedError'),
          });
        })
        .finally(() => setSending(false));

    } catch (error) {
      FxLog.errorx('MxClientNci.send', error);
      setSending(false);
    }
  };

  if (sentOk) {
    return (
      <div
        style={{
          width: formWidth,
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '120px',
        }}
      >
        <h2>{getMessage('formTitle')}</h2>
        {companyName && (
          <div
            style={{
              fontSize: '12px',
              marginTop: '2px',
              opacity: 0.8,
            }}
          >
            {companyName}
          </div>
        )}
        <div
          style={{
            marginTop: 8,
            color: 'var(--ibs_color_green)',
          }}
        >
          {sendStatus.message || getMessage('success')}
        </div>
      </div>
    );
  }

  if (sending) {
    return (
      <div
        style={{
          width: formWidth,
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '120px',
        }}
      >
        <h3 style={{ margin: 0 }}>{getMessage('sending')}</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        width: formWidth,
        margin: 'auto',
        display: 'flex',
        flexFlow: 'column wrap',
        justifyContent: 'center',
      }}
    >
      <h3>{(companyName || '').toUpperCase()}</h3>

      {sendStatus.message && (
        <div
          style={{
            marginBottom: 8,
            color:
              sendStatus.type === 'success'
                ? 'var(--ibs_color_green)'
                : 'var(--ibs_color_red)',
          }}
        >
          {sendStatus.message}
        </div>
      )}

      <div
        style={{
          marginTop: '2px',
          border: '1px solid var(--ibs_color_gray_light)',
          padding: '5px',
          borderRadius: '6px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <h3
          style={{
            margin: 0,
            color: 'var(--ibs_color_cy_blue)',
          }}
        >
          {getMessage('tutorTitle')}
        </h3>

        <CxInput
          xref={null}
          label={getMessage('firstNameLabel')}
          maxLength={100}
          value={clientData.txClient_firstName}
          onChange={(v) => {
            handleClientChange('txClient_firstName', v || '');
            rf_clientFullName_error.current?.setVisible(false);
          }}
          onBlur={() =>
            handleClientChange(
              'txClient_firstName',
              capitalize(clientData.txClient_firstName.trim())
            )
          }
        />

        <CxInput
          xref={null}
          label={getMessage('lastNameLabel')}
          maxLength={100}
          value={clientData.txClient_lastName}
          onChange={(v) => {
            handleClientChange('txClient_lastName', v || '');
            rf_clientFullName_error.current?.setVisible(false);
          }}
          onBlur={() =>
            handleClientChange(
              'txClient_lastName',
              capitalize(clientData.txClient_lastName.trim())
            )
          }
        />

        <CxStatic
          xref={rf_clientFullName_error}
          fontcolor="var(--ibs_color_red)"
          visible={'false'}
          margin={'4px 0 0 0'}
        />

        {lang !== 'de' && lang !== 'ru' && (
          <CxInput
            xref={null}
            label={getMessage('icLabel')}
            maxLength={20}
            value={clientData.txIc}
            onChange={(v) => handleClientChange('txIc', v || '')}
            onBlur={() =>
              handleClientChange(
                'txIc',
                clientData.txIc.trim().toUpperCase()
              )
            }
          />
        )}

        <CxInput
          xref={null}
          label={getMessage('emailLabel')}
          maxLength={255}
          value={clientData.txEmail}
          onChange={(v) => handleClientChange('txEmail', v || '')}
          onBlur={() =>
            handleClientChange(
              'txEmail',
              clientData.txEmail.trim().toLowerCase()
            )
          }
        />

        <CxInput
          xref={null}
          label={getMessage('phoneLabel')}
          maxLength={30}
          value={clientData.txMobile}
          onChange={(v) => handleClientChange('txMobile', v || '')}
        />

        <CxInput
          xref={null}
          label={getMessage('addressLabel')}
          maxLength={200}
          value={clientData.txAddress}
          onChange={(v) => handleClientChange('txAddress', v || '')}
          onBlur={() =>
            handleClientChange(
              'txAddress',
              capitalize(clientData.txAddress.trim())
            )
          }
        />

        <CxInput
          xref={null}
          label={getMessage('cityLabel')}
          maxLength={100}
          value={clientData.txCity}
          onChange={(v) => handleClientChange('txCity', v || '')}
          onBlur={() =>
            handleClientChange(
              'txCity',
              capitalize(clientData.txCity.trim())
            )
          }
        />

        <CxInput
          xref={null}
          label={getMessage('postalCodeLabel')}
          maxLength={10}
          value={clientData.txPostalCode}
          onChange={(v) =>
            handleClientChange('txPostalCode', v || '')
          }
        />
      </div>

      {showPatientForm && (
        <div
          style={{
            marginTop: '20px',
            border: '1px solid var(--ibs_color_gray_light)',
            padding: '5px',
            borderRadius: '6px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <h3
            style={{
              margin: 0,
              color: 'var(--ibs_color_cy_blue)',
            }}
          >
            {getMessage('patientTitle')}
          </h3>

          <CxInput
            xref={rfPatientRefs.txAnimal}
            label={getMessage('nameLabel')}
            maxLength={100}
          />

          <CxDate
            xref={rfPatientRefs.dtBirth}
            label={getMessage('birthDateLabel')}
          />

          <CxInput
            xref={rfPatientRefs.txTypeSpecies}
            label={getMessage('speciesLabel')}
            maxLength={50}
          />

          <CxInput
            xref={rfPatientRefs.txTypeBreed}
            label={getMessage('breedLabel')}
            maxLength={50}
          />

          <CxInput
            xref={rfPatientRefs.txTypeCoat}
            label={getMessage('coatLabel')}
            maxLength={50}
          />

          <CxCombo
            xref={rfPatientRefs.boGender}
            label={getMessage('genderLabel')}
            list={[
              { id: '0', type: getMessage('male') },
              { id: '1', type: getMessage('female') },
            ]}
          />

          <CxInput
            xref={rfPatientRefs.txChip}
            label={getMessage('chipLabel')}
            maxLength={50}
          />

          <CxInput
            xref={rfPatientRefs.txPassport}
            label={getMessage('passportLabel')}
            maxLength={50}
          />

          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'row',
              gap: '8px',
            }}
          >
            <CxButton
              label={getMessage('savePatient')}
              onClick={() => {
                addPatient();
                setShowPatientForm(false);
              }}
            />

            <CxButton
              label={getMessage('cancelPatient')}
              onClick={() => {
                clearPatientFields();
                setShowPatientForm(false);
              }}
            />
          </div>
        </div>
      )}

      {patients.length > 0 && (
        <div style={{ marginTop: '12px' }}>
          <h4 style={{ margin: '4px 0' }}>
            {getMessage('patientsAdded')}
          </h4>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
            }}
          >
            {patients.map((p, i) => (
              <li
                key={i}
                style={{
                  borderBottom:
                    '1px solid var(--ibs_color_gray_light)',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>{p.txAnimal}</span>
                <CxButton
                  small
                  label={getMessage('remove')}
                  onClick={() => removePatient(i)}
                />
              </li>
            ))}
          </ul>
        </div>
      )}

      {showAddPatientButton && !showPatientForm && (
        <div style={{ marginTop: '12px' }}>
          <CxButton
            label={getMessage('addPatient')}
            onClick={handleBottomAddPatient}
            width='100%'
          />
        </div>
      )}

      <div style={{ marginTop: '20px' }}>
        <CxButton label={getMessage('sendData')} onClick={send} width='100%' />
      </div>
    </div>
  );
};

export default MxClientNci;
